<template>
    <div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">

        <div style="padding: 15px;" v-show="showSearch">
            <van-cell-group>

                <div style="text-align: center; background-color: #fff; padding: 20px;">
                    {{ school_name }}
                    <br>
                    <span style="font-size: 20px;">新生报到</span>
                </div>
                <div style="height: 50px;"></div>
                <van-field v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" />
                <van-field v-model="stuForm.identity_card" label="身份证号" placeholder="请输入身份证号" />
                <div style="height: 50px;"></div>
                <div class="submitBtn flexAround">
                    <div class="btn" @click="onSearch" style="width: 40%;">开始报到</div>
                </div>
                <div style="height: 50px;"></div>
            </van-cell-group>
        </div>

        <div style="padding: 15px;" v-show="!showSearch">
            <div style="text-align: center; background-color: #fff; padding: 20px;">{{ school_name }}</div>
            <van-cell-group>

                <van-field readonly v-model="stuForm.stu_name" label="姓名" placeholder="请输入姓名" />
                <van-field readonly :value="stuForm.gender == 1 ? '男' : '女'" label="性别" placeholder="请输入姓名" />
                <van-field v-model="stuForm.phone" label="手机号" placeholder="请输入手机号" />

                <van-field readonly v-model="stuForm.major_name" label="专业" placeholder="" />

                <van-field readonly v-model="stuForm.xuezhi" label="学制" placeholder="" />

                <van-field readonly v-model="stuForm.class_name" label="班级" placeholder="" />
                <van-field readonly :value="stuForm.bzr ? stuForm.bzr.username : ''" label="班主任" placeholder="" />
                <van-field readonly :value="stuForm.bzr ? stuForm.bzr.phone : ''" label="手机号" placeholder="" />

            </van-cell-group>
            <div style="height:10px " v-if="stuForm.zhusu"></div>
            <van-cell-group v-if="stuForm.zhusu">
                <div class="rowlb">
                    <span></span>
                    住宿信息
                    <div style="float: right; font-weight: normal; color: orangered; font-size: 12px;">
                    </div>

                </div>
                <div style="padding:10px">
                    {{ stuForm.zhusu.building }}&nbsp;&nbsp;{{ stuForm.zhusu.floor }}&nbsp;&nbsp;{{ stuForm.zhusu.dorm_name }}&nbsp;&nbsp;{{ stuForm.zhusu.bed }}号床
                </div>
            </van-cell-group>
            <div style="height:10px "></div>

            <van-cell-group v-if="stuForm.pjson">
                <div class="rowlb">
                    <span></span>
                    军训服尺码
                    <div style="float: right; font-weight: normal; color: orangered; font-size: 12px;">
                    </div>

                </div>

                <van-field v-model="stuForm.pjson.height" label="身高(CM)" type="digit" placeholder="请输入身高数字">
                </van-field>
                <van-field v-model="stuForm.pjson.weight" label="体重(KG)" type="digit" placeholder="请输入体重数字">
                </van-field>



                <div id="">

                    <table class="datatable" cell-spacing="1" cell-padding="0" style="font-size: 12px;">
                        <tr>
                            <th style="width: 10%;">型号</th>
                            <th style="width: 10%;">M</th>
                            <th style="width: 10%;">L</th>
                            <th style="width: 10%;">XL</th>
                            <th style="width: 10%;">2XL</th>
                            <th style="width: 10%;">3XL</th>
                            <th style="width: 10%;">4XL</th>
                            <th style="width: 10%;">5XL</th>
                            <th style="width: 10%;">6XL</th>
                            <th style="width: 10%;">其他</th>

                        </tr>
                        <tr>
                            <td>建议身高</td>
                            <td @click="stuForm.pjson.size = 'M'">150-155</td>
                            <td @click="stuForm.pjson.size = 'L'">155-160</td>
                            <td @click="stuForm.pjson.size = 'XL'">160-165</td>
                            <td @click="stuForm.pjson.size = '2XL'">165-170</td>
                            <td @click="stuForm.pjson.size = '3XL'">170-175</td>
                            <td @click="stuForm.pjson.size = '4XL'">175-180</td>
                            <td @click="stuForm.pjson.size = '5XL'">180-185</td>
                            <td @click="stuForm.pjson.size = '6XL'">185-190</td>
                            <td @click="stuForm.pjson.size = 'O'">特殊体型</td>
                        </tr>
                        <tr>
                            <td>体重(kg)</td>
                            <td @click="stuForm.pjson.size = 'M'">45-50</td>
                            <td @click="stuForm.pjson.size = 'L'">50-55</td>
                            <td @click="stuForm.pjson.size = 'XL'">55-60</td>
                            <td @click="stuForm.pjson.size = '2XL'">60-65</td>
                            <td @click="stuForm.pjson.size = '3XL'">65-70</td>
                            <td @click="stuForm.pjson.size = '4XL'">70-75</td>
                            <td @click="stuForm.pjson.size = '5XL'">75-80</td>
                            <td @click="stuForm.pjson.size = '6XL'">80-85</td>
                            <td @click="stuForm.pjson.size = 'O'">特殊体型</td>
                        </tr>
                        <tr style="cursor: pointer;">
                            <td>点击选择</td>
                            <td style="font-size: 30px; color: orangered;" @click="stuForm.pjson.size = 'M'">
                                <i class="el-icon-success" v-if="stuForm.pjson.size == 'M'"></i>
                            </td>
                            <td style="font-size: 30px; color: orangered;" @click="stuForm.pjson.size = 'L'">
                                <i class="el-icon-success" v-if="stuForm.pjson.size == 'L'"></i>
                            </td>
                            <td style="font-size: 30px; color: orangered;" @click="stuForm.pjson.size = 'XL'">
                                <i class="el-icon-success" v-if="stuForm.pjson.size == 'XL'"></i>
                            </td>
                            <td style="font-size: 30px; color: orangered;" @click="stuForm.pjson.size = '2XL'">
                                <i class="el-icon-success" v-if="stuForm.pjson.size == '2XL'"></i>
                            </td>
                            <td style="font-size: 30px; color: orangered;" @click="stuForm.pjson.size = '3XL'">
                                <i class="el-icon-success" v-if="stuForm.pjson.size == '3XL'"></i>
                            </td>
                            <td style="font-size: 30px; color: orangered;" @click="stuForm.pjson.size = '4XL'">
                                <i class="el-icon-success" v-if="stuForm.pjson.size == '4XL'"></i>
                            </td>
                            <td style="font-size: 30px; color: orangered;" @click="stuForm.pjson.size = '5XL'">
                                <i class="el-icon-success" v-if="stuForm.pjson.size == '5XL'"></i>
                            </td>
                            <td style="font-size: 30px; color: orangered;" @click="stuForm.pjson.size = '6XL'">
                                <i class="el-icon-success" v-if="stuForm.pjson.size == '6XL'"></i>
                            </td>
                            <td style="font-size: 30px; color: orangered;" @click="stuForm.pjson.size = 'O'">
                                <i class="el-icon-success" v-if="stuForm.pjson.size == 'O'"></i>
                            </td>
                        </tr>
                    </table>
                </div>

                <van-field v-if="stuForm.pjson.size == 'O'" v-model="stuForm.pjson.remark" label="特殊体型说明"
                    placeholder="请输入特殊体型说明">
                </van-field>



                <div class="rowlb">
                    <span></span>
                    鞋码
                    <div style="float: right; font-weight: normal; color: orangered; font-size: 12px;">
                    </div>

                </div>

                <div style="padding: 10px;">
                    <div :class="['xm', item == stuForm.pjson.shoes ? 'xmckd' : '']" v-for="(item, idx) in shoes" :key="idx"
                        @click="stuForm.pjson.shoes = item">
                        {{ item }}
                    </div>
                </div>


                <van-field name="uploader6" label="电子证件照">
                    <template #input>
                        <div class="imagebox" style="height: 120px;" @click="setImageType('dzzj')">
                            <van-icon name="photo-o" v-if="!stuForm.pjson.dzzj" />
                            <img v-else :src="stuForm.pjson.dzzj" style="width: 100%; height: 100%;">

                        </div>


                    </template>
                </van-field>



            </van-cell-group>
            <div style="height:10px " v-if="stuForm.zhusu"></div>
            <van-cell-group v-if="stuForm.zhusu">
                <div class="rowlb">
                    <span></span>
                    学校平面图
                  
                </div>
                <div style="padding:10px"> 
                   <img :src="'/images/sczz.jpg'" style="width:100%" v-viewer />
                </div>
            </van-cell-group>
            <div style="height:10px "></div>

            <div style="height: 10px;"></div>
            <div class="submitBtn flexAround">
                <div class="btn" @click="confirmBD" v-if="!loading" style="width: 40%;">完成报到</div>
            </div>
            <div style="height: 50px;"></div>



        </div>


    </div>
</template>
<script>
import {
    Dialog,
    Toast,
    Uploader
} from 'vant';
export default {
    data() {
        return {

            showSearch: false,
            loading: false,
            school_name: "",
            shoes: [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45],
            imgname: "",
            stuForm: {
                stu_name: "",
                identity_card: ""
            },
            dzzj: ""
        }
    },
    mounted() {
        this.pmid = this.$route.query.pmid
        this.openid = this.$route.query.openid

        $(".page").height($(window).height())
        document.title = "新生报到"

        if (localStorage.getItem("data")) {
            let data = JSON.parse(localStorage.getItem("data"))
            localStorage.removeItem("data")
            for (let k in data) {
                this[k] = data[k]
            }
            //填充电子证件照
            if (this.$route.query.dzzj) {
                if (this.$route.query.dzzj == "undefined") {
                    Toast("未识别到人脸")
                } else {
                    this.stuForm.pjson.dzzj = decodeURIComponent(this.$route.query.dzzj)
                }

            }
        } else {

            this.getStudents()
            this.getSchoolName()
        }
        this.loadScript("//res2.wx.qq.com/open/js/jweixin-1.6.0.js", e => {
            this.checkUrlSign(wx)
        })

    },
    methods: {
        loadScript(url, callback) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            if (script.readyState) { //IE
                script.onreadystatechange = function () {
                    if (script.readyState == "loaded" ||
                        script.readyState == "complete") {
                        script.onreadystatechange = null;
                        callback();
                    }
                };
            } else { //Others: Firefox, Safari, Chrome, and Opera
                script.onload = function () {
                    callback();
                };
            }
            script.onerror = function (e) { }
            script.src = url;
            window.document.body.appendChild(script);
        },
        getSchoolName() {
            this.$http.post("/api/app_platform_info", {
                pmid: this.pmid
            }).then(res => {
                this.school_name = res.data.platform
            })
        },
        onSearch() {
            if (this.stuForm.identity_card) {
                this.$http.post("/api/app_stuinfo", {
                    pmid: this.pmid,
                    identity_card: this.stuForm.identity_card
                }).then(res => {
                    if (res.data) {

                        this.stuForm = res.data
                        this.checkLuqu()
                    } else {
                        this.showSearch = true
                    }

                })
            }
        },
        getStudents() {

            this.$http.post("/api/app_stuinfo", {
                pmid: this.pmid,
                openid: this.openid
            }).then(res => {
                if (res.data) {

                    this.stuForm = res.data
                    this.checkLuqu()
                } else {
                    this.showSearch = true
                }

            })
        },
        checkLuqu() {
            this.$http.post("/api/app_luqu_check", {
                pmid: this.pmid,
                stu_code: this.stuForm.exam_num,
                openid: this.openid
            }).then(res => {
                if (res.data) {
                    this.$http.post("/api/stu_luqu_detail", {
                        pmid: this.pmid,
                        id: res.data.id
                    }).then(res2 => {
                        if (res2.data) {
                            if (res2.data.pjson) {
                                res2.data.pjson = JSON.parse(res2.data.pjson)
                                if (!res2.data.pjson.height) {
                                    res2.data.pjson.height = ""
                                }
                                if (!res2.data.pjson.weight) {
                                    res2.data.pjson.weight = ""
                                }
                                if (!res2.data.pjson.size) {
                                    res2.data.pjson.size = ""
                                }
                                if (!res2.data.pjson.shoes) {
                                    res2.data.pjson.shoes = ""
                                }
                                if (!res2.data.pjson.remark) {
                                    res2.data.pjson.remark = ""
                                }
                            }
                            this.stuForm = res2.data
                        }

                        this.showSearch = false

                    })
                }

            })

        },
        setImageType(e) {
            this.imgname = e
            if (this.imgname == "dzzj") {
                let data = {}
                for (let k in this) {
                    if (k.indexOf("_") == 0 || k.indexOf("$") == 0 || k.indexOf("[") == 0 || typeof (this[k]) ==
                        "function" || k == 'asyncLocalStorage') {

                    } else {

                        data[k] = this[k]
                    }
                }

                localStorage.setItem("data", JSON.stringify(data))
                let href = window.location.href
                href = decodeURIComponent(href)
                if (href.indexOf("&dzzj") > 0) {
                    href = href.split("&dzzj")[0]
                }
                wx.miniProgram.redirectTo({
                    url: "/pages/camera_dzzj/dzzj?back=" + encodeURIComponent(href)
                })
            } else {
                //this.chooseImageWx()
            }
        },
        confirmBD() {
            this.stuForm.stu_id = this.stuForm.id
            this.loading = true
            this.$http.post("/api/sch_stu_report_edit", this.stuForm).then(res => {
                if (res.data) {
                    Toast.success("报到成功")
                    localStorage.removeItem("data")
                }

                setTimeout(() => {
                    this.loading = false
                }, 3000);
            })

        }
    }

}

</script>



<style lang="less" type="text/less">
.van-radio__icon {
    font-size: 16px;
}

.van-radio__icon--checked .van-icon {
    background-color: #00cfdc;
    border-color: #00cfdc;
}

.submitBtn {
    margin-top: 2vh;
    margin-bottom: 50px;

    .btn {
        display: inline-block;
        padding: 1.4vh 8%;
        background-color: #00CFDC;
        color: #fff;
        font-size: 15px;
        border-radius: 5vw;
        width: 50%;
        text-align: center;
    }

    .btn:active {

        background-color: #007AFF;

    }
}

.imagebox {
    border: 1px dotted #ccc;
    width: 100px;
    height: 100px;
    background-color: #F2F3F5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    color: #ccc
}

.xm {
    border: 1px solid #ccc;
    display: inline-block;
    margin: 0 10px 10px 0;
    padding: 4px 10px;
    border-radius: 4px;
}

.xmckd {
    background-color: orangered;
    color: #fff;
}
</style>
